<template>
    <div>
        <div class="content">
            <div class="leftBox">
                <div class="topInputBox">
                    <div class="searchInputBox" :style="isFocused?'border:1px solid #fff;':''">
                        <input class="searchInput" v-model="keyword" ref="myInput" :style="isFocused?'border-bottom:1px solid #ddd;':''" @focus="isFocused = true" @blur="inputblur()" type="text" placeholder="请输入">
                        <img class="clostBtn" v-show="isFocused && keyword!=''" @click="keyword = ''" src="../assets/images/inputClostBtn.png" alt="">
                        <el-switch
                            class="changeBtn"
                            style="display: block"
                            v-model="ifAI"
                            active-text="智搜"
                            active-color="#409eff">
                        </el-switch>
                        <img class="searchIcon" @click="searchDataForWeb()" src="../assets/images/searchIcon.png" alt="">
                    </div>
                    <div class="bottomBox1" v-show="isFocused && keyword.length == 0" :style="isFocused?'border: 1px solid #206daf':''">
                        <div class="historyBox">
                            <div class="historyTitle">
                                <span>历史搜索</span>
                                <img class="delIcon" @click="deleteUserSearchHistory()" src="../assets/images/searchDeleteIcon.png" alt="">
                            </div>
                            <div class="historyList">
                                <div class="historyItem" @click="changeKeyWord(item)" v-for="(item, index) in historyListData" :key="index">
                                    {{ item.keyword }}
                                </div>
                            </div>
                        </div>
                        <div class="hotBox">
                            <div class="hotTitle">
                                <img class="hotIcon" src="../assets/images/searcHotIcon.png" alt="">
                                宠医热搜</div>
                            <div class="hotList">
                                <div class="hotItem" @click="changeKeyWord(item)" v-for="(item, index) in hotListData" :key="index">
                                    <div class="indexNum">{{ index + 1 }}</div> 
                                    <div class="hotStr">
                                        {{ item.keyword }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bottomBox1" v-show="isFocused && keyword.length > 0" :style="isFocused?'border: 1px solid #206daf':''">
                        <div class="keyHostList">
                            <div class="keyHostItem" @click="changeKeyWord({keyword: item.keyword})" v-for="(item, index) in KeywordAutoCompleteDataList" :key="index">
                                <img class="SearchIcon" src="../assets/images/searchIcon2.png" alt="">
                                <div v-html="item.keywordStr"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- AI流式回复 -->
                <div class="AIBox" v-show="textOver != 0" >
                    <div v-show="textOver == 1">{{ task }}</div>
                    <div class="AITextContent" v-html="replyText" v-mathjax :style="AITextContentHeight?'height:auto;':''"></div>
                    <div class="jumpBtnBox" v-show="textOver == 2">
                        <span @click="jumpWebAi()">重新问AI</span>
                    </div>
                    <div class="openBtn" @click="AITextContentHeight = !AITextContentHeight">
                        <span v-show="!AITextContentHeight && replyText.length > 100">展开全文</span>
                        <span v-show="AITextContentHeight">收起</span>
                    </div>
                </div>
                <!-- 搜索到的内容 -->
                <el-tabs class="searchContent" v-model="dataType" @tab-click="handleClick">
                    <el-tab-pane label="全部" name="0">
                        <div class="toast" v-show="searchContentData.length == 0">
                            <div class="noData" v-if="keyword && searchOff">
                                <img class="noDataImg" src="../assets/images/searchNoData.png" alt="">
                                <div class="noDataText">暂无搜索结果</div>
                            </div>
                            <span v-else>请输入你要搜索的关键字</span>
                        </div>
                        <div class="livecont videocont" v-show="searchContentData.length > 0">
                            <div class="liveitem" v-for="(item, index) in searchContentData" :key="index" @click="jumpNewVideoDetail(item)">
                                <div class="themeimg">
                                    <img class="viodeimgitem default" :src="item.image?imgSrc + item.image:require('../assets/images/default.jpg')">
                                </div>
                                <div class="videoinfo">
                                    <div class="name" v-html="item.title"></div>
                                    <div class="livetime">{{ item.createTime.slice(0,10) }}</div>
                                </div>
                            </div>
                        </div>
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="total"
                            :page-size="count"
                            style="margin: 0 0 20px;"
                            v-show="searchContentData.length > 0"
                            @current-change="changeBtn">
                        </el-pagination>
                    </el-tab-pane>
                    <el-tab-pane label="课程" name="15">
                        <div class="toast" v-show="searchContentData.length == 0">
                            <div class="noData" v-if="keyword && searchOff">
                                <img class="noDataImg" src="../assets/images/searchNoData.png" alt="">
                                <div class="noDataText">暂无搜索结果</div>
                            </div>
                            <span v-else>请输入你要搜索的关键字</span>
                        </div>
                        <div class="livecont videocont" v-show="searchContentData.length > 0">
                            <div class="liveitem" v-for="(item, index) in searchContentData" :key="index" @click="jumpNewVideoDetail(item)">
                                <div class="themeimg">
                                    <img class="viodeimgitem default" :src="item.image?imgSrc + item.image:require('../assets/images/default.jpg')">
                                </div>
                                <div class="videoinfo">
                                    <div class="name" v-html="item.title"></div>
                                    <div class="livetime">{{ item.createTime.slice(0,10) }}</div>
                                </div>
                            </div>
                        </div>
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="total"
                            :page-size="count"
                            style="margin: 0 0 20px;"
                            v-show="searchContentData.length > 0"
                            @current-change="changeBtn">
                        </el-pagination>
                    </el-tab-pane>
                    <el-tab-pane label="医讯" name="3">
                        <div class="toast" v-show="searchContentData.length == 0">
                            <div class="noData" v-if="keyword && searchOff">
                                <img class="noDataImg" src="../assets/images/searchNoData.png" alt="">
                                <div class="noDataText">暂无搜索结果</div>
                            </div>
                            <span v-else>请输入你要搜索的关键字</span>
                        </div>
                        <div class="livecont videocont" v-show="searchContentData.length > 0">
                            <div class="liveitem" v-for="(item, index) in searchContentData" :key="index" @click="jumpNewVideoDetail(item)">
                                <div class="themeimg">
                                    <img class="viodeimgitem default" :src="item.image?imgSrc + item.image:require('../assets/images/default.jpg')">
                                </div>
                                <div class="videoinfo">
                                    <div class="name" v-html="item.title"></div>
                                    <div class="livetime">{{ item.createTime.slice(0,10) }}</div>
                                </div>
                            </div>
                        </div>
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="total"
                            :page-size="count"
                            style="margin: 0 0 20px;"
                            v-show="searchContentData.length > 0"
                            @current-change="changeBtn">
                        </el-pagination>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="rightBox">
                <img class="searchBanner" @click="jumpmember()" src="../assets/images/searchBanner1.png" alt="">
                <!-- <img class="searchBanner searchBanner2" src="../assets/images/searchBanner2.png" alt=""> -->
                <div class="GradeStudyListBox">
                    <div class="titles">分级学习</div>
                    <div class="gradeStudyList">
                        <div class="gradeStudyItem" @click="jumpgradeStudy(item)" v-for="(item, index) in GradeStudyDataList" :key="index">
                            <img class="itemIcon" :src="imgSrc + item.grade_image" alt="">
                            <div class="itemInfo">
                                <div class="name">
                                    {{ item.grade_name }}
                                </div>
                                <div class="number">
                                    {{ item.skill_count }}个模块
                                </div>
                                <div class="number">
                                    {{ item.data_count }}节课程
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Cookies from 'js-cookie'
import hex_md5 from "../assets/js/md5"
import { marked } from 'marked';
export default {
    data() {
        return {
			imgSrc: "https://case.chongyike.com",
            index: 0,
            count: 9,
            keyword: "",
            dataType: "0",
            // 搜索防抖
            searchDataForWebOff: false,
            // 历史记录
            historyListData: [],
            // 搜索内容展示
            searchContentData: [],
            // 搜索到的总数量
            total: 0,
            // 点过搜索按钮
            searchOff: false,
            // 设置回车键防抖
            loadingTime: {},
            // 分级学习
            GradeStudyDataList: [],
            // 输入框是否有焦点
            isFocused: false,
            // 热门搜索
            hotListData: [],
            // 匹配字符时防抖
            keywordTime: {},
            // 关键词匹配列表
            KeywordAutoCompleteDataList: [],
            // AI参数
            replyText: "",
            // 流式回复ID
            conversationId: "",
            // AI回复ID
            atPresentConversationID: "",
            // marked格式回复
            markedText: "",
            // AI回复展开收起
            AITextContentHeight: false,
            // 回复状态
            task: "思考中。。。",
            textOver: 0,
            // 会话ID
            sessionId: "",
            // 是否使用智搜
            ifAI: false
        }
    },
    created(){
        const that = this
        that.getUserSearchHistory()
        that.getGradeStudy()
        that.getHotSearchRecords()
        if(that.Cookies.get('searchText')){
            this.keyword = that.Cookies.get('searchText')
            that.Cookies.remove('searchText')
            this.searchDataForWeb()
        }
        // if(this.$route.query.text){
        //     this.keyword = this.$route.query.text
        //     this.searchDataForWeb()
        // }
    },
    watch: {
        isFocused(){
            console.log('输入框焦点:'+this.isFocused)
        },
        keyword(){
            clearTimeout(this.keywordTime)
            // 回车键搜索
            this.keywordTime = setTimeout(() => {
                this.searchKeywordAutoComplete(); // 1秒后执行搜索操作
            }, 300);
        },
    },
    mounted() {
        window.removeEventListener("keydown", this.keydownClick)
        window.addEventListener("keydown", this.keydownClick)
        // this.$nextTick(() => {
        //     if (this.$refs.input) {
        //         this.$refs.input.focus();
        //     }
        // });
    },
    methods: {
        // 视频跳转
		jumpNewVideoDetail(item){
            const that = this
            if(item.dataType == "15"){
                // 15跳转视频
                var data = {
                    dataType: 0,
                    No: item.dataNo,
                    name: item.title,
                    classType: 1,
                }
                that.$router.push({
                    path: '/videoDetail',
                    query: {
                        text: that.encrypt(JSON.stringify(data))
                    }
                })
            }else if(item.dataType == "A97"){
                that.jumpVideolistInner(item)
            }else if(item.dataType == "3"){
                that.jumpPostDetail(item)
            }
		},
        // 跳转直播详情
        jumpLiveDetail(item){
            const that = this
            that.$router.push({
                path: '/liveDetail/' + item.dataNo,
            })
        },
        // 跳转执兽视频
        jumpVideoDetail(item){
            const that = this
            var data = {
                dataType: 9,
                No: item.dataNo,
				name: item.title,
                classType: 1,
            }
            that.$router.push({
                path: '/trainVetVideoDetail',
                query: {
                    text: that.encrypt(JSON.stringify(data))
                }
            })
        },
		// 跳转宠医资讯
        jumpPostDetail(item){
            this.$router.push({
                path: "/postDetail/" + item.dataNo,
            })
        },
		// 跳转分级学习
		jumpgradeStudy(item){
			this.$router.push({
				path: "/gradeStudy/" + item.grade_id,
			})
		},
		// 跳转分级学习
		jumpmember(){
            const that = this
            that.$router.push({
                path: '/member',
            })
		},
        // 跳转视频详情
        jumpVideolistInner(item){
            const that = this
			var data = {
                type: "getSeriesFirstVideoInfo",
				classId: item.dataNo
			}
			that.get('/3/mobileHandler', data, 1).then(res => {
                if (res.data.code == "success") {
                    var result = res.data.result
					var data = {
						dataType: 0,
						No: result.video_no,
						name: result.video_name,
						classType: 1,
						classId: item.class_id
					}
					that.$router.push({
						path: '/videoDetail',
						query: {
							text: that.encrypt(JSON.stringify(data))
						}
					})
                }
			})
        },
        // 跳转AI
        jumpWebAi(){
            const that = this
            var data = {
                question: that.keyword,
				intention: "20"
            }
			sessionStorage.setItem("AiQuestion", JSON.stringify(data))
            that.$router.push({
                path: '/webAi',
            })
        },
        // 按下回车搜索
        keydownClick(e){
            const that = this 
            var keyCode = e.keyCode
            if(keyCode == "13" && that.$route.path == '/search' && that.isFocused){
                clearTimeout(that.loadingTime)
                // 回车键搜索
                this.loadingTime = setTimeout(() => {
                    this.searchDataForWeb(); // 1秒后执行搜索操作
                }, 100);
            }
        },
        // 获取历史记录
        getUserSearchHistory(){
			const that = this
            var data = { 
                type: 'getUserSearchHistory',
            }
            this.get("/webhttp/mobileHandler",data).then((res)=>{
                if(res.data.code == "success"){
                    var result = res.data.result
                    that.historyListData = result
                }else {
                    console.log(res.data.message)
                }
            })
        },
        // 获取热门搜索
        getHotSearchRecords(){
			const that = this
            var data = { 
                type: 'getHotSearchRecords',
            }
            this.get("/webhttp/mobileHandler",data).then((res)=>{
                if(res.data.code == "success"){
                    var result = res.data.result
                    that.hotListData = result
                }else {
                    console.log(res.data.message)
                }
            })
        },
        // 搜索匹配
        searchKeywordAutoComplete(){
			const that = this
            var data = { 
                type: 'searchKeywordAutoComplete',
                content: that.keyword
            }
            this.get("/webhttp/mobileHandler",data, 1).then((res)=>{
                if(res.data.code == "success"){
                    var result = res.data.result
                    var arr = []
                    for (let i = 0; i < result.length; i++) {
                        var datas = {
                            keyword: result[i]
                        }
                        if(result[i].indexOf(that.keyword) > -1){
                            datas.keywordStr = result[i].replace(that.keyword,'<font color=\"#206DAF\">' + that.keyword + '</font>')
                        }else {
                            datas.keywordStr = result[i]
                        }
                        arr.push(datas)
                    }
                    that.KeywordAutoCompleteDataList = arr
                }else {
                    console.log(res.data.message)
                }
            })
        },
		// 获取分级学习
		getGradeStudy() {
			const that = this
			var data = {
                type: "getGradeStudy",
			}
			that.get('/3/gradeStudy', data).then(res => {
                if (res.data.code == "success") {
                    var result = res.data.result
					that.GradeStudyDataList = result
                }
			})
		},
        // 搜索方法
        searchDataForWeb(){
			const that = this
            if(this.searchDataForWebOff){
                return false
            }
            if(that.keyword.trim() == ""){
                this.$message({
                    showClose: true,
                    message: '请输入搜索内容~',
                    type: 'error'
                });
                return false
            }
            this.searchDataForWebOff = true
            // 是否使用智搜
            if(this.ifAI){
                if (that.Answering) {
                    that.stopAnswerts()
                    setTimeout(() => {
                        that.submitQuestion()
                    }, 500);
                }else {
                    that.submitQuestion()
                }
            }
            that.searchContentData = []
            var data = { 
                type: 'searchDataForWeb',
                dataType: that.dataType,
                pageNum: that.index,
                pageSize: that.count,
                content: that.keyword,
            }
            this.get("/webhttp/mobileHandler",data ,1).then((res)=>{
                that.searchOff = true
                if(res.data.code == "success"){
                    var result = res.data.result
                    // if(that.dataType != 0){
                    that.total = res.data.totalPage
                    that.searchContentData = result
                    this.searchDataForWebOff = false
                    // }else {
                    //     that.searchOff = true
                    //     that.total = result[0].totalNumber + result[1].totalNumber
                    //     that.searchContentData = [...result[0].dataList, ...result[1].dataList]
                    // }
                }
            })
        },
        // 清空历史记录
        deleteUserSearchHistory(){
            const that = this
            var data = { 
                type: 'deleteUserSearchHistory',
            }
            this.get("/webhttp/mobileHandler",data ,1).then((res)=>{
                if(res.data.code == "success"){
                    var result = res.data.result
                    console.log(result)
                    that.historyListData = []
                    that.$message('清空成功');
                }
            })
        },
        // 切换标签页
        handleClick(tab, event) {
            const that = this
            that.index = 0
            that.dataType = tab.name
            if(that.keyword.trim() != ""){
                that.searchDataForWeb()
            }
        },
        // 点击历史记录
        changeKeyWord(item){
            const that = this
            that.keyword = item.keyword
            that.searchDataForWeb()
        },
        // 翻页
        changeBtn(e){
            const that = this
            that.index = e-1
            that.searchDataForWeb()
        },
        // 失去焦点
        inputblur(){
            const that = this
            setTimeout(() => {
                that.isFocused = false
            }, 300);
        },
        // AI=============================================================
        // 发送问题
        submitQuestion() {
            const that = this
            // 是否正在回答
            if (that.Answering) {
                that.stopAnswerts()
            } else {
                that.textOver = 0
                // 开始问答
                that.startAnswer = true
                that.Answering = true
                var uploadFile = new FormData();
                // 数组添加新提问
                uploadFile.append("question", that.keyword);
                var data = {
                    type: 'submitQuestion',
                    conversationId: '',
                    conversationType: 2,
                    accessType: 7, // 7是官网
                    connectedInternet: 0,
                    mode: 0,
                    llmType: 0,
                    intention: "20",
                }
                this.post("/ai/handler3", data, uploadFile).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        // document.title = that.textMsg.slice(0, 10) + "- 智答"
                        if (sessionStorage.getItem("AiQuestion")) {
                            sessionStorage.removeItem("AiQuestion")
                        }
                        // that.markedTextlength += 1
                        that.sessionId = result.session_id
                        // 建立流式回复
                        that.connectToServer(result.session_id)
                        that.textOver = 1
                    } else {
                        that.Answering = false
                        that.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            }
        },
        // 建立流式回复
        connectToServer(sessionId) {
            const that = this
            let url = 'https://appinterface.chongyike.com/ai/handler3?type=getAnswers&sessionId=' + sessionId + that.getConfigText()
            // url = 'http://192.168.18.121:82/ai/handler2?type=getAnswers&sessionId='+ sessionId + that.getConfigText()
            // 建立连接
            let sourceInfo = new EventSource(url);
            // 保存原文参数
            var markedText = ""
            that.replyText = ""
            // var jump_keys = []
            sourceInfo.onmessage = function (e) {
                var data = JSON.parse(e.data)
                that.task = data.task
                markedText += data.content
                // that.markedTextlength = markedText.length
                that.replyText = marked(markedText).replace(/<del>|<\/del>/g, "");
                // if (data.finishReason == -1) {
                //     jump_keys = data.jump_keys
                // }
                // 回复结束
                if (data.finishReason == 1) {
                    var datatext = that.replyText
                    // that.replyText = that.highlightHtm4(that.escapeUnescapedSquareBrackets(datatext), jump_keys)
                    that.replyText = that.escapeUnescapedSquareBrackets(datatext)
                    that.conversationId = data.conversationID
                    that.atPresentConversationID = data.conversationID // 保存当前问答ID
                    // 是否结束流式回复
                    that.textOver = 2
                    // 点赞时使用会话ID
                    that.sessionId = data.sessionId
                    that.markedText = markedText
                    // that.markedTextlength = 0
                    that.task = "思考中"
                }
            }
            sourceInfo.addEventListener('error', function (e) {
                that.Answering = false
                sourceInfo.close();
            }, false);
        },
        // 停止流式回复
        stopAnswerts() {
            const that = this
            var data = {
                type: 'stopAnswerts',
                sessionId: that.sessionId
            }
            this.get("/ai/handler3", data, 1).then((res) => {
                if (res.data.code == "success") {
                    var result = res.data.result
                    that.Answering = false
                    if (that.replyText == "思考中。。。") {
                        that.replyText = ""
                    }
                    that.textOver = 0
                }
            })
        },
        getConfigText() {
            const that = this
            // 获取当前时间
            var time = (new Date()).getTime();
            var data = {
                // 接口来源 安卓/IOS/WEB
                client: "WEB",
                // 版本号
                device: "",
                // 时间戳
                requestTime: time,
                // 版本号
                versionCode: 251,
            }
            if (Cookies.get('device')) {
                data.device = Cookies.get('device')
            } else {
                var lsnms = num();
                var strs = time + "" + lsnms;
                var device = hex_md5(strs).toUpperCase();
                Cookies.set('device', device, { expires: 7 })
                data.device = device
            }
            data.sign = that.serSign(data)
            var texts = ""
            for (let key in data) {
                if (data.hasOwnProperty(key)) {
                    texts += "&" + key + "=" + data[key]
                }
            }
            return texts
        },
        serSign(data) {
            var text = ""
            for (let key in data) {
                text = text + key + '=' + data[key] + "&"
            }
            return hex_md5(text + 'key=huiyichongyike')
        },
        // 处理文本
        escapeUnescapedSquareBrackets(str) {
            // 首先转义所有已有的反斜杠，以避免影响后续的匹配
            let result = str.replace(/\\/g, '\\\\');

            // 定义一个函数来决定是否需要在 [ 或 ] 前添加 \\
            function shouldEscape(match, offset, string) {
                // 计算 match 之前有多少个反斜杠
                let backslashes = (string.slice(0, offset).match(/\\+/g) || ['']).pop() || '';
                // 如果反斜杠的数量是偶数（包括0），则需要转义
                return backslashes.length % 2 === 0;
            }
            // 使用正则表达式替换未被转义的 [ 和 ]
            result = result.replace(/([[\]])/g, (match, p1, offset, string) => shouldEscape(match, offset, string) ? '\\\\' +
                p1 : p1);
            result = result.replace(/([(\)])/g, (match, p1, offset, string) => shouldEscape(match, offset, string) ? '\\\\' +
                p1 : p1);

            // 恢复原有的单个反斜杠
            result = result.replace(/\\\\/g, '\\');
            return result;
        }
    },
}
</script>

<style lang="scss" scoped>
    .content {
        display: flex;
        justify-content: space-between;
    
        .leftBox {
            width: 750px;
            .topInputBox {
                position: relative;
                border: 1px solid #fff;
                box-sizing: border-box;
                .bottomBox1 {
                    position: absolute;
                    top: -1px;
                    left: 0;
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    padding-top: 50px;
                    min-height: 0px;
                    z-index: 10;
                    border-radius: 10px;
                    background-color: #fff;
                    .historyBox {
                        width: 420px;
                        padding: 10px 15px 10px 20px;
                        box-sizing: border-box;
                        .historyTitle {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            font-size: 14px;
                            color: #1A1A1A;
                            padding-bottom: 10px;
                            user-select: none;
                            .delIcon {
                                width: 20px;
                                height: 20px;
                                cursor: pointer;
                            }
                        }
                        .historyList {
                            display: flex;
                            flex-wrap: wrap;
                            .historyItem {
                                padding: 3px 8px;
                                margin-right: 5px;
                                margin-bottom: 5px;
                                border: 1px solid #ccc;
                                border-radius: 100px;
                                color: #555;
                                font-size: 14px;
                                user-select: none;
                                cursor: pointer;
                                &:hover {
                                    border: 1px solid #206daf;
                                }
                            }
                        }
                    }
                    .hotBox {
                        width: 300px;
                        padding: 10px 0 10px 0;
                        box-sizing: border-box;
                        .hotTitle {
                            display: flex;
                            align-items: center;
                            font-size: 14px;
                            color: #FF5E2B;
                            padding-bottom: 5px;
                            user-select: none;
                            .hotIcon {
                                width: 20px;
                            }
                        }
                        .hotList {
                            .hotItem{
                                display: flex;
                                align-items: center;
                                padding: 3px 0;
                                font-size: 16px;
                                color: #252525;
                                cursor: pointer;
                                .indexNum {
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    width: 20px;
                                    height: 20px;
                                    font-size: 14px;
                                    border-radius: 5px;
                                    margin-right: 10px;
                                    color: #bfbfbf;
                                }
                                .hotStr {
                                    width: 260px;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                }
                                &:hover {
                                    color: #206DAF;
                                }
                                &:nth-child(1){
                                    .indexNum {
                                        color: #fff;
                                        background-color: #ff5858;
                                    }
                                }
                                &:nth-child(2){
                                    .indexNum {
                                        color: #fff;
                                        background-color: #ff8058;
                                    }
                                }
                                &:nth-child(3){
                                    .indexNum {
                                        color: #fff;
                                        background-color: #ffd358;
                                    }
                                }
                            }
                        }
                    }

                    .keyHostList {
                        width: 100%;
                        box-sizing: border-box;
                        padding: 10px 20px;
                        border-radius: 10px;
                        .keyHostItem {
                            display: flex;
                            align-items: center;
                            padding: 10px 10px;
                            color: #191919;
                            font-size: 14px;
                            background-color: #fff;
                            user-select: none;
                            cursor: pointer;
                            .SearchIcon {
                                width: 18px;
                                height: 18px;
                                margin-right: 10px;
                            }
                            &:hover {
                                background-color: #f2f6fa;
                            }
                        }
                    }
                }
                .searchInputBox {
                    position: relative;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 10px;
                    height: 50px;
                    border: 1px solid #ccc;
                    border-radius: 100px;
                    z-index: 11;
                    background-color: #fff;
                    margin-left: 1px;
                    .searchInput {
                        width: 600px;
                        height: 50px;
                        padding-left: 10px;
                        font-size: 16px;
                        box-sizing: border-box;
                        border: none;
                        outline: none;
                    }
                    .clostBtn {
                        position: absolute;
                        width: 15px;
                        right: 160px;
                        cursor: pointer;
                    }
                    .searchIcon {
                        width: 25px;
                        margin-right: 10px;
                        cursor: pointer;
                    }
                }
            }
        }
        
    }

    .AIBox {
        padding: 15px;
        margin: 15px 0;
        border-radius: 10px;
        border: 1px solid #ccc;
        .AITextContent {
            overflow: auto;
            height: 150px;
        }
        .jumpBtnBox {
            display: flex;
            flex-direction: row-reverse;
            padding: 10px 0;
            span {
                color: #fff;
                background-color: #206DAF;
                padding: 5px 10px;
                border-radius: 5px;
                cursor: pointer;
            }
        }
        .openBtn {
            text-align: center;
            color: #206DAF;
            cursor: pointer;
            user-select: none;
        }
    }

    .searchContent {
        margin-top: 10px;
        
		.livecont {
			display: flex;
            padding: 10px 0;
            flex-wrap: wrap;
			cursor: pointer;

			.liveitem {
				width: 215px;
				border-radius: 5px;
                margin-right: 25px;
                margin-bottom: 20px;
				box-shadow: 1px 5px 7px rgba(187, 187, 187, 0.65);
                &:nth-child(3n){
                    margin: 0;
                    margin-bottom: 20px;
                }
				&:hover {
					box-shadow: 2px 7px 11px rgb(217, 232, 247);
				}

				.price {
					color: #00AA80;
					.vipprice {
						margin-left: 0.875rem;
						color: #C3911C;
					}
				}
				.themeimg {
					position: relative;
					border-radius: 5px;
					width: 215px;
					height: 120px;
					overflow: hidden;

					.viodeimgitem {
						position: absolute;
						left: 0;
						top: 0;
                        width: 215px;
                        height: 120px;
						border-radius: 5px;
						object-fit: cover;
                        // background-image: url("../assets/images/default.png");
					}

					.absolutbox {
						position: absolute;
						display: flex;
						justify-content: space-between;
						align-items: center;
						left: 0;
						bottom: 0;
						width: 100%;
						padding: 3px 10px;
						box-sizing: border-box;
						color: #fff;
						font-size: 14px;
						border-radius: 5px;
						background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.78) 100%);
						cursor: pointer;

						i {
							font-size: 18px;
						}
					}

					.livepricebox {
						position: absolute;
						right: 0;
						top: -2px;
						font-size: 14px;

						.forfree {
							padding: 0 3px;
							color: #6aac29;
							border-radius: 2px;
							background: rgba(231, 249, 213, 0.9);
						}

						.vipprice {
							padding: 0 3px;
							border-radius: 2px;
							color: #e09119;
							background: rgba(255, 243, 226, 0.7);
						}
					}
				}

				.videoinfo {
					padding: 10px;

					.name {
						color: rgba(68, 68, 68, 1);
						font-weight: 600;
						font-size: 18px;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
					}

					.teacher {
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 1;
						-webkit-box-orient: vertical;
						color: #444444;
						font-size: 14px;
						font-weight: 400;
					}

					.livetime {
						font-size: 14px;
						font-weight: 400;
                        padding-top: 5px;
					}
				}
			}
		}

        .newsbox {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            padding: 5px;
            .newsItem {
                display: flex;
                align-items: center;
                width: 49%;
                height: 100px;
                padding: 0 10px;
                box-sizing: border-box;
                margin-bottom: 20px;
                border-radius: 6px;
				box-shadow: 1px 5px 7px rgba(187, 187, 187, 0.65);
                cursor: pointer;
                .newsImg {
                    width: 80px;
                    height: 80px;
                    margin-right: 10px;
                    border-radius: 6px;
                }
            }
        }
    }
    
	.rightBox {
		width: 400px;
        display: flex;
        align-items: center;
        flex-direction: column;
        .searchBanner {
            width: 380px;
            margin-bottom: 20px;
            cursor: pointer;
        }
		.GradeStudyListBox {
            width: 380px;
            background: linear-gradient(180deg, #e6efff, #fff);
			border-radius: 10px;
			border: 1px solid #ececec;
			margin-bottom: 20px;
            border: 2px solid #cadeef;
			.titles {
				font-size: 24px;
				color: #444;
				height: 46px;
				padding: 20px;
				font-weight: 600;
			}
			.gradeStudyList {
				display: flex;
				align-items: center;
				justify-content: space-between;
				flex-wrap: wrap;
				padding: 0 20px;
				font-weight: 600;
				.gradeStudyItem {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 160px;
					height: 92px;
					margin-bottom: 15px;
					border-radius: 5px;
					color: #333;
					background-color: #fff;
					box-shadow: 0 0 10px 2px #f8f8f8;
					cursor: pointer;
					&:hover {
						color: #206DAF;
						box-shadow: 2px 7px 11px rgb(217, 232, 247);
					}
					.itemIcon {
						width: 40px;
						height: 40px;
						margin-right: 20px;
					}
					.itemIcon2 {
						width: 50px;
						height: 50px;
						margin-right: 15px;
					}
					.itemInfo {
						display: flex;
						flex-direction: column;
						.name {
							font-size: 16px;
							padding-bottom: 6px;
						}
						.number {
							font-size: 13px;
							font-weight: 500;
						}
					}
				}
			}
		}

		.GradeStudyListBox2 {
			background: linear-gradient(180deg, #f2f1ff, #fff);
		}
	}

    .noData {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .noDataImg {
            width: 300px;
        }
        .noDataText {
            color: #838383;
            font-size: 16px;
        }
    }
</style>